import React, { useMemo, useState } from "react";
import Select from "@8x8/oxygen-select";
import { PencilInBoxIcon } from "@8x8/oxygen-icon";

import {
  ColumnSetterInfoContainer,
  ColumnSetterActionContainer,
  FullWidthDiv,
  InlineBlock,
} from "@/react/features/styled";
import { Button } from "@/react/styled";
import { useColumnWideSet } from "@/react/components/table/components";

import { PHONE_CHANNEL_FORMATS, PHONE_CHANNEL_TYPES } from "./constants";

const OPTIONS = PHONE_CHANNEL_FORMATS.map((phoneChannelFormat) => ({
  label: phoneChannelFormat,
  value: phoneChannelFormat,
}));

const FormatColumnSetter = (props) => {
  const { table, rows, column } = props;
  const areRowsEditable = useMemo(
    () =>
      rows?.every((row) => row?.original?.type === PHONE_CHANNEL_TYPES.TENANT),
    [rows]
  );
  const columnId = column.id;
  const firstFormat = rows[0]?.getValue(columnId);
  const [format, setFormat] = useState(firstFormat);
  const onSet = useColumnWideSet(table, columnId);

  if (!areRowsEditable) {
    return (
      <InlineBlock marginLeft={8}>
        Type for the selected {rows.length} {rows.length === 1 ? "row" : "rows"}{" "}
        must be "tenant".
      </InlineBlock>
    );
  }

  const selectedFormat = OPTIONS.find((option) => option.value === format);

  return (
    <>
      <ColumnSetterInfoContainer>
        <PencilInBoxIcon size={18} />
        <InlineBlock marginLeft={8}>
          Set value for{" "}
          <span>
            {rows.length} {rows.length === 1 ? "row" : "rows"}
          </span>
        </InlineBlock>
      </ColumnSetterInfoContainer>
      <ColumnSetterActionContainer>
        <FullWidthDiv>
          <Select
            testId={"format-select-column-setter"}
            value={selectedFormat}
            options={OPTIONS}
            onChange={(opt) => setFormat(opt?.value)}
            isClearable={true}
            isSearchable={true}
          />
        </FullWidthDiv>
        <Button marginLeft={8} onClick={() => onSet(format)}>
          Set
        </Button>
      </ColumnSetterActionContainer>
    </>
  );
};

export default FormatColumnSetter;
